var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"search-experience-note",class:_vm.noteClass},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"search-experience-note-link",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('switch')}}},[_vm._v(_vm._s(_vm.action))])])
}
var staticRenderFns = []

export { render, staticRenderFns }